import pickBy from 'lodash/pickBy';

const settingsOverwrite = pickBy(window.settingsOverwrite || {}, Boolean);
const envVariablesOverride = pickBy(
  {
    ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
    ENABLED_FEATURES: process.env.REACT_APP_ENABLED_FEATURES,
    MAP_ACCESS_TOKEN: process.env.REACT_APP_MAP_ACCESS_TOKEN,
    SEARCH_FEDERATION_ACCESS_TOKEN:
      process.env.REACT_APP_SEARCH_FEDERATION_ACCESS_TOKEN,
    CONTRIBUTE_API_ACCESS_TOKEN:
      process.env.REACT_APP_CONTRIBUTE_API_ACCESS_TOKEN,
    CONTRIBUTE_API_URL: process.env.REACT_APP_CONTRIBUTE_API_URL,
    CONTRIBUTE_PRIVATE_API_URL:
      process.env.REACT_APP_CONTRIBUTE_INTERNAL_API_URL,
    SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
    BASE_URL_PATH: process.env.REACT_APP_BASE_URL_PATH,

    POI_TILESET: process.env.REACT_APP_POI_TILESET,
    POI_SOURCE_ID: process.env.REACT_APP_POI_SOURCE_ID,
    POI_SOURCE_LAYER: process.env.REACT_APP_POI_SOURCE_LAYER,
    POI_STREETS_STYLE_URL: process.env.REACT_APP_POI_STREETS_STYLE_URL,
    POI_SATELLITE_STYLE_URL: process.env.REACT_APP_POI_SATELLITE_STYLE_URL,
    POI_HYBRID_STYLE_URL: process.env.REACT_APP_POI_HYBRID_STYLE_URL,

    ROAD_TILESET: process.env.REACT_APP_ROAD_TILESET,
    ROAD_SOURCE_ID: process.env.REACT_APP_ROAD_SOURCE_ID,
    ROAD_SOURCE_LAYER: process.env.REACT_APP_ROAD_SOURCE_LAYER,
    ROAD_STREETS_STYLE_URL: process.env.REACT_APP_ROAD_STREETS_STYLE_URL,
    ROAD_SATELLITE_STYLE_URL: process.env.REACT_APP_ROAD_SATELLITE_STYLE_URL,
    ROAD_HYBRID_STYLE_URL: process.env.REACT_APP_ROAD_HYBRID_STYLE_URL,

    BUILDING_TILESET: process.env.REACT_APP_BUILDING_TILESET,
    BUILDING_SOURCE_ID: process.env.REACT_APP_BUILDING_SOURCE_ID,
    BUILDING_SOURCE_LAYER: process.env.REACT_APP_BUILDING_SOURCE_LAYER,
    BUILDING_STREETS_STYLE_URL:
      process.env.REACT_APP_BUILDING_STREETS_STYLE_URL,
    BUILDING_SATELLITE_STYLE_URL:
      process.env.REACT_APP_BUILDING_SATELLITE_STYLE_URL,
    BUILDING_HYBRID_STYLE_URL: process.env.REACT_APP_BUILDING_HYBRID_STYLE_URL,
  },
  Boolean,
);

// default config is a development one
const configRaw = {
  ...envVariablesOverride,
  ...settingsOverwrite,
};

interface Config {
  ENVIRONMENT: string;
  ENABLED_FEATURES: Set<string>;
  MAP_ACCESS_TOKEN: string;
  SEARCH_FEDERATION_ACCESS_TOKEN: string;
  CONTRIBUTE_API_ACCESS_TOKEN: string;
  CONTRIBUTE_API_URL: string;
  CONTRIBUTE_PRIVATE_API_URL: string;
  SENTRY_DSN: string;
  BASE_URL_PATH: string;

  POI_TILESET: string;
  POI_SOURCE_ID: string;
  POI_SOURCE_LAYER: string;
  POI_STREETS_STYLE_URL: string;
  POI_SATELLITE_STYLE_URL: string;
  POI_HYBRID_STYLE_URL: string;

  ROAD_TILESET: string;
  ROAD_SOURCE_ID: string;
  ROAD_SOURCE_LAYER: string;
  ROAD_STREETS_STYLE_URL: string;
  ROAD_SATELLITE_STYLE_URL: string;
  ROAD_HYBRID_STYLE_URL: string;

  BUILDING_TILESET: string;
  BUILDING_SOURCE_ID: string;
  BUILDING_SOURCE_LAYER: string;
  BUILDING_STREETS_STYLE_URL: string;
  BUILDING_SATELLITE_STYLE_URL: string;
  BUILDING_HYBRID_STYLE_URL: string;
}

const config = {
  ...configRaw,
  ENABLED_FEATURES: new Set(
    ((configRaw.ENABLED_FEATURES as string) || '')
      .split(',')
      .map((f) => f.trim()),
  ),
} as Config;

export default config;
